import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, EventEmitter, Output } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { RIDE_TYPES } from '../shared/constants';
@Component({
  selector: 'app-live-status-update',
  template: require('./live-status-update.component.html')
})
export class LiveStatusUpdateComponent implements OnInit, OnChanges, OnDestroy {
  @Input('data') data: any;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  public name: string;
  public number: string;
  public currentTime: Date = new Date();
  public updatedTime: Date = new Date();
  public lastUpdated = 0;
  public status: string;
  public eta = 0;
  public subscriber: any;
  public ownerName: string;
  public customerName: string;
  public rideOrOrder: string;
  public dataLoaded = false;
  public stauses = ['onTheWay', 'arrived', 'started', 'reached'];
  public bookForSomeoneElse: any;
  public orderType: string;
  public serviceDisplayName: string;

  constructor() { }

  ngOnInit() {
    this.getLiveStatus(this.data);
    this.subscriber = Observable.interval(500).subscribe(() => {
      this.currentTime = new Date();
      this.lastUpdated = this.currentTime.getMinutes() - this.updatedTime.getMinutes();
      this.lastUpdated = Math.abs(this.lastUpdated);
    });
    this.reloadData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      if (changes.data.currentValue) {
        const data = changes.data.currentValue;
        const riderObj = this.resolveRiderObj(data);
        if (riderObj) {
          this.getLiveStatus(Object.assign({}, data, { riderObj }));
        }
      }
    }
  }

  resolveRiderObj(data: any): any {
    if (data.riderObj && data.riderObj.riderInfo) {
      return data.riderObj;
    }

    if (data.captain) {
      const captain = data.captain;
      const vehicle = captain.vehicleObj || captain.vehicle || {};
      return {
        avgRating: captain.avgRating != null ? captain.avgRating : captain.rating,
        vehicleObj: {
          number: vehicle.number || captain.vehicleNumber || '',
          make: vehicle.make || captain.vehicleMake || '',
        },
        riderInfo: {
          name: captain.name || '',
          mobile: captain.mobile || captain.phone || '',
          profilePicture: captain.profilePicture || captain.profilePic || '',
        },
      };
    }

    return null;
  }

  getLiveStatus(data) {
    this.dataLoaded = true;
    if (data) {
      this.name = data.riderObj.riderInfo.name;
      this.bookForSomeoneElse = data.bookForSomeoneElse;
      this.customerName = this.bookForSomeoneElse ? data.bookForSomeoneElse.customer.name : data.customerObj.name;
      this.ownerName = RIDE_TYPES.includes(data.orderType) ? this.customerName : 'Captain';
      this.rideOrOrder = RIDE_TYPES.includes(data.orderType) ? 'ride' : 'order';
      this.status = data.status;
      this.eta = data.riderLocation && data.riderLocation.eta || this.eta;
      this.updatedTime = new Date();
      this.orderType = data.orderType;
      this.serviceDisplayName = data.serviceType && data.serviceType.service && data.serviceType.service.displayName ? data.serviceType.service.displayName : '';
      document.title = this.customerName ? this.customerName + '\'s Rapido' : 'Rapido';
    }
  }

  reloadData() {
    this.reload.emit(true);
  }
  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

}
